module.exports = __webpack_public_path__ + "static/media/empty-status.77d829cb.png";